import React from 'react';
import {connect} from 'react-redux';

import { Button, Icon } from 'semantic-ui-react';

const goToURL = url => event => {
    event.preventDefault();

    const a = document.createElement('a');
    a.style.display = 'none';
    a.target = "_blank";
    a.href = url;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
};



const ButtonLinkRoomConference = ({ label = '', profesional, ...otherProps }) =>
    profesional && profesional.urlSala
        ?
            <Button onClick={goToURL(profesional.urlSala)} color="red" icon {...otherProps}>
                {label}<Icon name="video"/>
            </Button>
        :
            ""
;

const mapStateToProps = state => ({
    profesional: state.auth && state.auth.data
});

const mapDispatchToProps = {};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ButtonLinkRoomConference);


// WEBPACK FOOTER //
// ./src/components/forms/ButtonLinkRoomConference.js